import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "../Styles/CheckListJugadores.css";
import { BASE_URL } from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CheckListJugadores = ({ idEquipo, idPartido }) => {
  const [jugadores, setJugadores] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [estadisticas, setEstadisticas] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}equipos/${idEquipo}/${idPartido}/personas`)
      .then((response) => {
        const jugadoresData = response.data.map((item) => {
          const estadisticas = item.estadisticas[0] || {}; 
          return {
            id: item.persona.id,
            nombre: item.persona.nombres,
            numero: estadisticas.numeroCamiseta || "", 
            foto: item.persona.fotografiaPath || "https://via.placeholder.com/50",
            checked: estadisticas.asistio === 1, 
            inicialista: estadisticas.inicialista === 1, 
          };
        });

        setJugadores(jugadoresData);
      })
      .catch((error) => {
        console.error("Error al obtener los datos:", error);
      });
  }, [idEquipo]);

  const handleCheckIndividual = (id) => {
    setJugadores((prevJugadores) =>
      prevJugadores.map((jugador) =>
        jugador.id === id ? { ...jugador, checked: !jugador.checked } : jugador
      )
    );
  };

  const handleCheckAll = (checked) => {
    setJugadores((prevJugadores) =>
      prevJugadores.map((jugador) => ({ ...jugador, checked }))
    );
  };

  const handleDorsalChange = (id, value) => {
    setJugadores((prevJugadores) =>
      prevJugadores.map((jugador) =>
        jugador.id === id ? { ...jugador, numero: value } : jugador
      )
    );
  };

  const handleInicialistaChange = (id) => {
    setJugadores((prevJugadores) =>
      prevJugadores.map((jugador) =>
        jugador.id === id ? { ...jugador, inicialista: !jugador.inicialista } : jugador
      )
    );
  };

  useEffect(() => {
    const selected = jugadores.filter((jugador) => jugador.checked);
    setSelectedPlayers(selected);
  }, [jugadores]);

  const handleSubmit = async () => {
    await obtenerEstadisticas();
      const jugadoresAEnviar = selectedPlayers
      .filter((jugador, index, self) => 
        index === self.findIndex((t) => t.id === jugador.id)  
      )
      .map((jugador) => ({
        idPersona: jugador.id,
        idPartido,
        idEquipo,
        inicialista: jugador.inicialista,
        numeroDorsal: jugador.numero || null,
        asistio: jugador.checked ? 1 : 0,
      }));
  
    if (jugadoresAEnviar.length === 0) {
      toast.error("No se seleccionaron jugadores para enviar.");
      return;
    }
  
    try {
      const response = await axios.post(`${BASE_URL}store-planilla-check`, { jugadores: jugadoresAEnviar });
      const { jugadoresGuardados, errores } = response.data;
  
      if (errores && errores.length > 0) {
        errores.forEach((error) => {
          if (error.message.includes("ya está agregada")) {
            toast.info(`Jugador ID ${error.idPersona} ya está registrado.`);
          } else {
            toast.error(`Error con el jugador ID ${error.idPersona}: ${error.message}`);
          }
        });
      }
  
      if (jugadoresGuardados && jugadoresGuardados.length > 0) {
        toast.success(`${jugadoresGuardados.length} jugadores registrados correctamente`);
      }
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      toast.error("Error al procesar la solicitud");
    }
  };
  
  
  const obtenerEstadisticas = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}get-estadisticas-partido/${idPartido}/${idEquipo}`
      );
      setEstadisticas(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [idPartido, idEquipo]);

  

  const validateDorsals = () => {
    return selectedPlayers.every((jugador) => jugador.numero !== "");
  };

  return (
    <div className="checklist-container">
      <h1>Asistencia Jugadores</h1>
      <table className="elevated-table">
        <thead>
          <tr>
            <th>Foto</th>
            <th>Nombre</th>
            <th>Dorsal</th>
            <th>Inicialista</th>
            <th>
              <div className="check-all-container">
                <button
                  className="btn-table"
                  onClick={() => handleCheckAll(true)}
                  title="Marcar Todo"
                >
                  ✔️
                </button>
                <button
                  className="btn-table"
                  onClick={() => handleCheckAll(false)}
                  title="Desmarcar Todo"
                >
                  ❌
                </button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {jugadores.map((jugador) => (
            <tr key={jugador.id}>
              <td>
                <img
                  src={jugador.foto}
                  alt={jugador.nombre}
                  className="player-photo"
                />
              </td>
              <td>{jugador.nombre}</td>
              <td>
                <input
                  type="text"
                  value={jugador.numero}
                  onChange={(e) => handleDorsalChange(jugador.id, e.target.value)}
                  placeholder="Dorsal"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={jugador.inicialista}
                  onChange={() => handleInicialistaChange(jugador.id)}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={jugador.checked}
                  onChange={() => handleCheckIndividual(jugador.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <hr />
      <button
        className="btn btn-success"
        onClick={handleSubmit}
        disabled={!validateDorsals()}
      >
        Enviar Asistencia
      </button>
    </div>
  );
};

export default CheckListJugadores;
